<template>
  <v-dialog v-model="localDialog" scrollable width="1024" lazy>
    <v-card>
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title>
          {{
            localGroup._id
              ? $t('titles.global.updateModel', { field: $tc('models.group') })
              : $t('titles.global.newModel', { field: $tc('models.group') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 px-2>
            <translation-field
              ref="name"
              v-model="localGroup.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>

          <v-flex sm6 xs12 px-2>
            <v-select
              v-model="localGroup.phaseId"
              v-validate="'required'"
              :readonly="!!localGroup._id"
              :label="
                $t('action.actions.select', { field: $tc('models.phase') })
              "
              :items="selectPhases"
              :data-vv-name="$tc('models.phase')"
              :error-messages="errors.collect($tc('models.phase'))"
            />
          </v-flex>
          <v-flex sm6 xs12 px-2>
            <pitch-field
              v-model="localGroup.pitch"
              v-validate="'required'"
              :tournament-id="tournamentId"
              multiple
              :label="
                $t('action.actions.select', { field: $tc('models.pitch', 2) })
              "
              :data-vv-name="$tc('models.pitch', 2)"
              :error-messages="errors.collect($tc('models.pitch', 2))"
            />
          </v-flex>
          <v-flex v-if="!isRandomMatches" xs12 px-2>
            <match-field
              v-model="localGroup.matches"
              :tournament-id="tournamentId"
              :exclude="selectedMatches"
              multiple
              :label="
                $t('action.actions.select', { field: $tc('models.match', 2) })
              "
            />
          </v-flex>
          <v-flex md2 xs4 px-2>
            <v-switch
              v-model="localGroup.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <template>
          <span style="color: red">(*) &nbsp;</span>
          <span>{{ $t('action.messages.fieldRequired') }}</span>
        </template>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button type="cancel" @click="cancel" />
        <meta-button
          v-if="!localGroup._id"
          type="create"
          :loading="loading"
          @click="submit"
        />
        <meta-button v-else type="update" :loading="loading" @click="submit" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MatchField from '@/components/widgets/Input/MatchField'
import PitchField from '@/components/widgets/Input/PitchField'
import TranslationField from '@/components/widgets/Input/TranslationField'

export default {
  name: 'DialogGroup',
  components: { TranslationField, PitchField, MatchField },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    type: {
      type: String,
      default: '',
      required: true,
    },
    group: {
      type: Object,
      default: () => {},
      required: true,
    },

    phases: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },

  computed: {
    ...mapState({
      tournamentId: (state) => state.tournaments.idSelected,
    }),

    localDialog: {
      get() {
        return this.dialog
      },
      set(value) {
        if (!value) this.cancel()
      },
    },
    localGroup: {
      get() {
        return this.group
      },
      set(value) {
        this.$emit('update:group', value)
      },
    },
    selectPhases() {
      return this.phases.map((phase) => ({
        text: this.getName(phase.name),
        value: phase._id,
      }))
    },
    selectedMatches() {
      let phasesMatches = []
      this.phases.forEach((phase) => {
        phase.groups.forEach((group) => {
          group.matches.forEach((match) => phasesMatches.push(match._id))
        })
      })
      return phasesMatches
    },
    isRandomMatches() {
      if (!this.localGroup.phaseId) return false
      const phase = this.phases.find(
        (phase) => phase._id === this.localGroup.phaseId
      )
      return phase && phase.randomMatches
    },
  },
  methods: {
    ...mapActions({
      reset: 'groups/reset',
    }),
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return
          this.$emit('submit')
        }
      )
    },
    addHour() {
      this.localGroup.hours.push(this.hour)
      this.hour = null
    },
    removeHour(index) {
      this.localGroup.hours.splice(index, 1)
    },
    clear() {
      this.$nextTick(() => {
        this.reset()
        this.entityId = ''
        this.$refs.name.$validator.reset()
        this.$validator.reset()
      })
    },
    cancel() {
      this.$emit('update:dialog', false)
      this.clear()
    },
  },
}
</script>
